import React, { useState,useEffect } from "react";
import Button from "@material-ui/core/Button";
import axios from "axios";
import * as yup from "yup";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";
import SelectContainer from "./selectContainer";
import SelectCountry from './selectCountry'
import SelectCountryCode  from './selectCountryCode'

import { Row, Col } from "reactstrap";

import moment from "moment";
import { API_CANDIDATE,RS_API } from "../../../utils/config";
import Navigation from "../../../common/Navigation";
// import Notifier from '../../aside/Notifier'
import ErrorNotifier from "../../aside/ErrorNotifier";
import Notifier from "../../aside/Notifier"
import { countries } from "countries-list";
import { API_AUTH } from "../../../utils/config";

// validate user component
const Validateuser = () => {
  let history = useHistory();

 
  const [error, seterror] = useState("");
  const [err, setErr] = useState("");
  const[getEmail,setGetEmail] = useState("")
  const[noOfYears,setnoOfYears] = useState("")
  const[errYears,setErrYears] = useState("")
  const[selectCandi,setSelectCandi] = useState("Experienced")
  const[countryList,setCountryList] = useState([])
  const[message,setMessage] = useState("")
  let isValid = true
  const onSubmit = async (values) => {
  
  let regex = "/^\d{0,2}\.\d{0,1}$/"
  let sample = `${noOfYears}`
  if(selectCandi === "Experienced"){
    if(sample.match(/^\d{0,3}\.\d{0,2}$/)){
      setErrYears("")
      isValid= true
    }
    else {
     setErrYears("Please enter years in 00.0 format");
     isValid=false
    }
  }
    
    
    
    // let date = new Date(values.datepic);
    let datePart = values.datepic.split('-')
    let date = new Date(datePart[0], datePart[1],datePart[2] )
    console.log(values.countryCode)
    // Add the time zone offset minutes to the date
    // date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
   

    let body = {
      firstName: values.firstName,
      lastName: values.lastName,
      dob: date,
      eMailId:getEmail,
      country: values.CountryName,
      gender: values.selectOptions,
      location: values.location,
      mobileNo: Number(values.MobileNumber),
      yearOfExp:Number(noOfYears),
      experienceType:selectCandi,
      dialingCode:values.countryCode
    };
  if(isValid){

  
    await axios
      .post(`${API_CANDIDATE}/v1/api/create-user/validate`, body, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.ok) {
          setMessage("Candidate Created Successfully");
          setTimeout(() => {
            setMessage("");
            history.push({
              pathname: "Uploadresume",
            });
          },2000);
        } else if (!response.data.ok) {
          seterror(response.data.error);
          setTimeout(() => {
            seterror("");
          }, 2000);
        }
      })
      .catch((error) => {
        if (!error.response.data.statusCode === 403) {
          console.log("going")
          seterror(error.response.data.message);
          setTimeout(() => {
            seterror("");
          }, 2000);
        } else if (error.response && error.response.data.statusCode === 403) {
          console.log("forbidden")
          seterror(error.response.data.message);
          setTimeout(() => {
            seterror("");
            history.push({
              pathname: "/signin",
            });
          }, 2000);
        }
      });
    }
    // }}
  };
  const textChecker = RegExp(/^[a-zA-Z\w\s\.\/\-]*$/gm);


// onchange function for checking candidate type
  const handleCandiTypeChange = (e) =>{
    if(e.target.value =="Fresher"){
      setnoOfYears(null)
    }
  setSelectCandi(e.target.value)
  }


  useEffect(() => {
    currentMailId()
    countryFetch()
  }, [])

  // getting current email id for candidate

 const currentMailId = () =>{
  axios.get(`${API_AUTH}/v1/api/auth/get-mail-id`,{withCredentials:true}).then((res)=>{
    console.log(res.data.data.email)
    if(res.data.ok){
      setGetEmail(res.data.data.email)
    }
   }).catch((err)=>{

  })
 }

//  get countries list from rs

 const countryFetch = () =>{
  axios.get(`${RS_API}/v1/api/can-country`,{withCredentials:true}).then((res)=>{
    setCountryList(res.data)
  
}).catch((err)=>{

  })
 }
 



// validation schema 

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const validateUserSchema = yup.object().shape({
    firstName: yup

      .string()
      .matches(textChecker, "First name is not valid")
      .min(2, "Too Short!")
      .max(23, "Too Long!")
      .required(" First name is required"),
    lastName: yup
      .string()
      .min(1, "Too Short!")
      .matches(textChecker, "Last name is not valid")
      .max(23, "Too Long!")
      .required("Last name is required"),

    CountryName: yup
      .string()
     
      .matches(textChecker, "country name is not valid")

      .required("Country name is required"),

    selectOptions: yup.string().required("Gender is required"),

    location: yup
      .string()
      .max(23, "Too Long!")
      .matches(textChecker, "location is not valid")

      .required("Location is required"),

    datepic: yup
      .date()
   
      .max(
        new Date(Date.now() - 473353890000),
        "You must be at least 15 years old"
      )
      .min(
        new Date(!Date.now() - 157784630000),
        "you are not a right candidate"
      )
      .required("Date is required"),

    MobileNumber: yup
      .string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Phone number is required")
      .min(10, "Phone number is not valid")
      .max(10, "Phone number is not valid"),
  });

  const DropdownOptions = [
    { key: "Select an Option", value: "" },
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
    { key: "Others", value: "Others" },
  ];

  // onchange function for changing years of exp
  const handleYearsChange = (e) =>{
    setnoOfYears(e.target.value)
    setErrYears("")
  }

  const candiOptions = [
    {key:"Experienced",value:"Experienced"},
    {key:"Fresher",value:"Fresher"},
   
  ]

  return (
    <div className="validatecontainer">
      <Navigation show="true" />
      <Formik
        validationSchema={validateUserSchema}
        initialValues={{
          firstName: "",
          lastName: "",
          location: "",
          CountryName: "",
          MobileNumber: "",
          selectOptions: "",
          countryCode:"IN",
          datepic: new Date(),
          droppic: "",
          noOfYears:0
        }}
        onSubmit={(values) => onSubmit(values)}
      >
        {({ errors, touched, values, handleChange, handleSubmit, isValid }) => (
          <>
            <div className="child-validatecontainer">
              <Row>
                <Col md="6">
                  <div
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span style={{ fontSize: "17px", fontWeight: 500 }}>
                      First Name
                    </span>
                    <input
                    tabIndex="1"
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      style={{ height: "40px", marginTop: "5px" }}
                      type="text"
                      name="firstname"
                      value={values.firstName}
                      onChange={handleChange("firstName")}
                      placeholder="First Name"
                      autoComplete="off"
                      required
                    ></input>
                    <span>
                      {" "}
                      {errors.firstName && touched.firstName ? (
                        <span style={{ fontSize: 13, color: "red" }}>
                          {errors.firstName}
                        </span>
                      ) : null}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "10px",
                    }}
                  >
                    <span style={{ fontSize: "17px", fontWeight: 500 }}>
                      Gender
                    </span>

                    <SelectContainer
                    tab="3"
                    widthValue="100%"
                      value={values.selectOptions}
                      onChange={handleChange("selectOptions")}
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      options={DropdownOptions}
                    />
                    <span>
                      {" "}
                      {errors.selectOptions && touched.selectOptions ? (
                        <span style={{ fontSize: 13, color: "red" }}>
                          {errors.selectOptions}
                        </span>
                      ) : null}
                    </span>
                  </div>
                  <span>{err}</span>

                  <div
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span style={{ fontSize: "17px", fontWeight: 500 }}>
                      Country Name
                    </span>
                    <SelectCountry
                    tab="5"
                    widthValue="100%"
                      value={values.CountryName}
                      onChange={handleChange("CountryName")}
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      options={countryList}
                    />
                    <span style={{ marginRight: "30px" }}>
                      {" "}
                      {errors.CountryName && touched.CountryName ? (
                        <span style={{ fontSize: 13, color: "red" }}>
                          {errors.CountryName}
                        </span>
                      ) : null}
                    </span>
                  </div>
                
                
                  <div
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span style={{ fontSize: "17px", fontWeight: 500 }}>
                      Location
                    </span>
                    <input
                     tabIndex="8"
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      style={{ height: "40px", marginTop: "5px" }}
                      type="text"
                      name="location"
                      value={values.location}
                      onChange={handleChange("location")}
                      placeholder="Location"
                      autoComplete="off"
                      required
                    ></input>
                    <span>
                      {" "}
                      {errors.location && touched.location ? (
                        <span style={{ fontSize: 13, color: "red" }}>
                          {errors.location}
                        </span>
                      ) : null}
                    </span>
                  </div>
                </Col>
                <Col md="6">
                  <div
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span style={{ fontSize: "17px", fontWeight: 500 }}>
                      Last Name
                    </span>
                    <input
                       tabIndex="2"
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      style={{ height: "40px", marginTop: "5px" }}
                      type="text"
                      name="lastName"
                      value={values.lastName}
                      onChange={handleChange("lastName")}
                      placeholder="Last Name"
                      autoComplete="off"
                      required
                    ></input>
                    {errors.lastName && touched.lastName ? (
                      <span style={{ fontSize: 13, color: "red" }}>
                        {errors.lastName}
                      </span>
                    ) : null}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "10px",
                    }}
                  >
                    <span style={{ fontSize: "17px", fontWeight: 500 }}>
                      DOB
                    </span>

                    <input
                     tabIndex="4"
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      max={moment().format("DD-MM-YYYY")}
                      style={{ height: "40px", marginTop: "5px" }}
                      type="date"
                      name="Number"
                      value={values.datepic}
                      onChange={handleChange("datepic")}
                      autoComplete="off"
                      required
                    ></input>
                    <span>
                      {" "}
                      {errors.datepic && touched.datepic ? (
                        <span style={{ fontSize: 13, color: "red" }}>
                          {errors.datepic}
                        </span>
                      ) : null}
                    </span>
                  </div>
               
                  <div
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span style={{ fontSize: "17px", fontWeight: 500 }}>
                      Phone Number
                    </span>
                    <div style={{display:"flex",width:"100%"}}>
                    <SelectCountryCode
                      tab="6"
                      widthValue="80px"
                      value={values.countryCode}
                      onChange={handleChange("countryCode")}
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      options={countryList}
                      select={values.CountryName}
                      countries={countries}
                    />

                    <input
                     tabIndex="7"
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      style={{ height: "40px", marginTop: "5px",width:"100%" }}
                      type="text"
                      name="MobileNumber"
                      value={values.MobileNumber}
                      onChange={handleChange("MobileNumber")}
                      placeholder="Phone Number"
                      autoComplete="off"
                      required
                    ></input>
                    </div>
                    <span>
                      {" "}
                      {errors.MobileNumber && touched.MobileNumber ? (
                        <span style={{ fontSize: 13, color: "red" }}>
                          {errors.MobileNumber}
                        </span>
                      ) : null}
                    </span>
                  </div>

                  <div
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span style={{ fontSize: "17px", fontWeight: 500 }}>
                      Work Experience
                    </span>

                    <div style={{display:"flex"}}>
                      <SelectContainer
                        tab="9"
                        widthValue="200px"
                       value={selectCandi}
                        onChange={handleCandiTypeChange}
                        onKeyPress={(e) => {
                          console.log(e);
                          if (e.code === "Enter") {
                            handleSubmit();
                          }
                        }}
                        options={candiOptions}
                      />
                      <div>
                      { selectCandi == "Experienced" &&   <input
                        tabIndex="10"
                        type="number"
                        name="noOfYears"
                        value={noOfYears}
                        onChange={handleYearsChange}
                        style={{marginLeft:"1rem",height:"42px",width:"100%"}}
                        autoComplete="off"
                        placeholder="00.0 (Number of Years)"
                        required
                      />}
                         <span>
                      {" "}
                      {errYears && (
                        <span style={{ fontSize: 13, color: "red",marginLeft:"2rem" }}>
                          {errYears}
                        </span>
                      ) }
                    </span>

                      </div>
                 
                    </div>
                 
                  </div>
                </Col>
              </Row>

              <div
                style={{
                  marginTop: "30px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                 tabIndex="11"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  style={{
                    background: "#005500",
                    color: "white",
                    width: "150px",
                  }}
                >
                  Next
                </Button>
              </div>
              {message && <Notifier message={message} />}
              {error && <ErrorNotifier message={error} />}
            </div>
          </>
        )}
      </Formik>
    </div>
  );
};

export default Validateuser;
